import { render, staticRenderFns } from "./CoachAdminCard.vue?vue&type=template&id=3529dd49"
import script from "./CoachAdminCard.vue?vue&type=script&lang=js"
export * from "./CoachAdminCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports